/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { PersonIcon } from '@radix-ui/react-icons';

import { css, styled } from 'fierry/react';

import { useBoundPreference } from 'solis/preferences';

import { OFFLINE } from 'solis/auth';


const USERS = [ 0, 1, 2, 3 ];


const Container = styled.div`
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  box-shadow: 0 0 0 1px var(--gray-a5);
  overflow: hidden;
`;


const Icon = styled.span`
  display: inline-flex;
  align-items: center;
  height: 40px;
  padding: 0 6px 0 14px;
  background: var(--gray-3);
  color: var(--gray-11);
`;


const Segment = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 40px;
  padding: 0;
  border: none;
  background: var(--gray-3);
  color: var(--gray-12);
  font: inherit;
  font-size: var(--font-size-2);
  cursor: pointer;

  &:hover { background: var(--gray-5); }
  &:active { background: var(--gray-6); }

  ${props => props.$selected && css`
    background: var(--accent-9);
    color: var(--accent-contrast);

    &:hover { background: var(--accent-9); }
    &:active { background: var(--accent-9); }
  `}
`;


export default () =>
{
  const [ user, setUser ] = useBoundPreference('currentUser', 1);

  const onPick = (index) => () =>
  {
    setUser(index);
  };

  if (!OFFLINE)
  {
    return null;
  }

  return (
    <Container>

      <Icon>
        <PersonIcon />
      </Icon>

      {USERS.map(index =>
      (
        <Segment key = {index} type = 'button' $selected = {index === user} onClick = {onPick(index)}>
          {index}
        </Segment>
      ))}

    </Container>
  );
};
